import React, { useState, useImperativeHandle, useEffect, forwardRef } from 'react'
import Api from '../../../../_helpers/Api'

//images
import docIcon from '../../../../assets/img/icons/document.png'
import closeIcon from '../../../../assets/img/icons/close.png'
import loader from '../../../../assets/img/loader.svg'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"
import { useHistory, useLocation } from 'react-router-dom'
import { trans } from '../../../../_providers/Translation'
import NoDataFound from '../../../partials/NoDataFound'
import { Tab, Tabs } from '@mui/material'

function History(props, ref) {
    const [activeTab, setActiveTab] = useState('all')

    const history = useHistory()
    const location = useLocation()

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        id: null,
        data: null,
        loading: true,
        update: false,
    })

    useImperativeHandle(ref, () => ({
        show: (id) => {
            setPopup(prev => ({
                ...prev,
                id: id,
                loading: true,
                update: Math.random().toString()
            }))
            handleShow()
        },
        hide: () => {
            handleHide()
        }
    }))

    // извлича текущите данни, за да се попълнят полетата

    useEffect(() => {
        if (!popup.id) return
        setPopup(prev => ({ ...prev, loading: true }))
        let endpoint = 'storage/history'
        Api.get(`${endpoint}?id=${popup.id}`)
            .then(res => {
                setPopup(prev => ({
                    ...prev,
                    data: res.data,
                    loading: false
                }))
            })
    }, [popup.id, popup.update, activeTab])

    const handleShow = () => {
        setPopup(prev => ({
            ...prev,
            overlay: true
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }))
        }, 50)
    }

    const handleHide = e => {
        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            modal: false,
            loading: false,
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false
            }))
        }, 50)
    }

    const showPartHistory = id => {
        setPopup(prev => ({
            ...prev,
            id: id,
            loading: true,
            update: Math.random().toString()
        }))
    }

    const showReservation = id => {
        history.push('/schedule/reservations/edit/' + id)
    }

    // Tab filtering logic
    let filteredData = popup.data
    if (Array.isArray(popup.data)) {
        if (activeTab === 'loads') {
            filteredData = popup.data.filter(h => h.action && h.action.toLowerCase().includes('load'))
        } else if (activeTab === 'outs') {
            filteredData = popup.data.filter(h => h.action && h.action.toLowerCase().includes('out'))
        } else if (activeTab === 'moves') {
            filteredData = popup.data.filter(h => h.action && h.action.toLowerCase().includes('move'))
        } else if (activeTab === 'corrections') {
            filteredData = popup.data.filter(h => h.action && h.action.toLowerCase().includes('manual'))
        }
    }

    return (
        <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
            <div className={`${popup.modal ? 'show' : ''} popup-primary`}>

                <div className='head-new'>
                    <img src={popupDefaultHeadImage} alt="icon" />
                    <div className='texts'>
                        <h2>
                            {location.pathname.includes('appliances')
                                ? trans('headings.applianceHistory')
                                : trans('headings.partHistory')} {popup.id ? `(ID ${popup.id})` : ''}
                        </h2>
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        </p>
                    </div>
                    <span className='close' onClick={handleHide}>

                    </span>
                </div>

                <Tabs
                    value={activeTab}
                    onChange={(e, newValue) => setActiveTab(newValue)}
                    variant="scrollable"
                    scrollButtons="auto"
                    indicatorColor="primary"
                    textColor="primary"
                    allowScrollButtonsMobile
                >
                    <Tab value="all" label={trans('tabs.all')} />
                    <Tab value="loads" label={trans('tabs.loads')} />
                    <Tab value="outs" label={trans('tabs.outs')} />
                    <Tab value="moves" label={trans('tabs.moves')} />
                    <Tab value="corrections" label={trans('tabs.corrections')} />
                </Tabs>

                {popup.loading
                    ?
                    <img src={loader} alt="loading" />
                    :
                    !filteredData || !Array.isArray(filteredData) || filteredData.length === 0
                        ?
                        <NoDataFound />
                        :
                        <div className="popup-container">
                            <div className="table-scroller">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>{trans('tables.activity')}</th>
                                            <th>{trans('tables.date')}</th>
                                            <th>{trans('tables.employee')}</th>
                                            <th>{trans('tables.category')}</th>
                                            <th>{trans('tables.name')}</th>
                                            <th>{trans('tables.partNumber')}</th>
                                            <th className="center">{trans('tables.oldQuantity')}</th>
                                            <th className="center">{trans('tables.quantity')}</th>
                                            <th className="center">{trans('tables.newQuantity')}</th>
                                            <th>{trans('tables.storage')}</th>
                                            <th>{trans('tables.van')}</th>
                                            {/* <th>{trans('tables.supplier')}</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData.map((h, i) => (
                                            <tr key={'ph-' + i}>
                                                <td>{trans('storage-activity.' + h.action)}</td>
                                                <td>{h.date}</td>
                                                <td>{h.employee}</td>
                                                <td>{h.category}</td>
                                                <td>{h.name}</td>
                                                <td>{h.part_number}</td>
                                                <td className="center">{h.old_quantity}</td>
                                                <td className="center">{h.quantity}</td>
                                                <td className="center">{h.new_quantity}</td>
                                                <td>{h.location_type === 'warehouse' ? h.location || '-' : '-'}</td>
                                                <td>{h.location_type === 'van' ? h.location || '-' : '-'}</td>
                                                {/* <td>{h.storeload?.supplier?.name || '-'}</td> */}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                }

                <div className="footer align-right">
                    <button className="button" onClick={handleHide}>
                        {trans('buttons.close')}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default forwardRef(History)